export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/expand-image.21516deb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};